import { api } from '../../../lib/api.js';

export async function fetchFeatureVisibility() {
  const res = await api.request({ url: 'mystep', method: 'GET' });
  return res.data;
}
